import React, { useContext } from 'react';
import style from './RenewNowModal.module.scss';
import { IPlan } from '../../model';
import classnames from 'classnames';
import { AppContext } from '../../context/AppContext';

interface IProps{
  plan: IPlan;
  close: () => void;
}

const RenewNowModal = ({
  close,
  plan
                       }: IProps) => {
  const { yearly, selectedOneTimeItem, baseCheckoutPath } = useContext(AppContext)
  const priceObject = !yearly ? plan?.prices.monthly : plan?.prices.yearly;

  return (
    <div className={classnames(style.renew_popup, 'modal active')}>
      <div className={"modal__overlay"} onClick={close}>
        <div className={classnames("modal__form", style.modal__form)} onClick={e => e.stopPropagation()}>
          <div className="modal__close" onClick={close}>
            <svg>
              <use href="images/sprite.svg#icon-modal-close"></use>
            </svg>
          </div>
          <div className="modal__form__title">Disclaimer</div>
          <div className="modal__form__text">
            <p>
              You are renewing your plan early. This will reset your billing period. You will have the opportunity to use a promo code
            </p>
          </div>
          <div className="modal__form__footer">
            <button
              className={classnames("modal__form__content__button button-secondary button-primary_md", style.modal__form__content__button)}
              onClick={close}
            >
              No
            </button>
            <a
              href={`${baseCheckoutPath}?price_id=${priceObject?.price_id}${selectedOneTimeItem ? `&otp_ids=[${selectedOneTimeItem.id}]` : ''}`}
              className={classnames("modal__form__content__button button-primary button-primary_md", style.modal__form__content__button)}
              onClick={() => {
                close()
              }}
            >
              Yes, renew
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenewNowModal;
